<script>
  import { urlServeur } from "../components/conf.js";
  import SalaireParPoste from "../components/SalaireParPoste.svelte";
  import Spinner from "../components/ToolsSpinner.svelte";

  let promise;
  let totalMasse = [];
  let x = -1; //aide au calcul du % augmentation salaire calcul sur année precedente
  /**
   *
   */
  const fetchData = async () => {
    const response = await fetch(urlServeur + "/api_employe/sal_moyen_by_year");
    if (response.ok) {
      const res = await response.json();
      //console.log(res.payload);
      return res.payload;
    }
  };

  /**
   * calcul du % augmentation masse salariale
   * @param salaire
   * @param prime : plus utilisé
   * @param autre : plus utilisé
   */
  const calculPercent = (masse) => {
    totalMasse.push(masse);
    x += 1;
    if (x == 0) {
      //premier element
      //console.log(" A- " + totalSalaire);
      return 0;
    } else {
      return Math.round(
        ((totalMasse[x] - totalMasse[x - 1]) * 100) / totalMasse[x - 1],
        2
      );
    }
  };

  promise = fetchData();
</script>

{#await promise}
  <Spinner />
{:then elements}
  <h5>Masse salariale</h5>
  <table class="table table-sm table-info">
    <thead>
      <tr>
        <td c>année</td>
        <td>Sal.Moy</td>
        <td>sal.mini</td>
        <td>Sal.maxi</td>
        <td>Prime</td>
        <td>Masse.sal</td>
        <td>%</td>
      </tr>
    </thead>
    <tbody>
      {#each elements as element}
        <tr>
          <td>{element.SA_ANNEE}</td>
          <td>{new Intl.NumberFormat("fr-FR").format(element.SALMOYEN)}</td>
          <td>{new Intl.NumberFormat("fr-FR").format(element.SALMINI)}</td>
          <td>{new Intl.NumberFormat("fr-FR").format(element.SALMAXI)}</td>
          <td> {new Intl.NumberFormat("fr-FR").format(element.PRIME)}</td>
          <td
            >{new Intl.NumberFormat("fr-FR").format(
              Math.round(parseFloat(element.MASSE), 2)
            )}</td
          >
          <td>{calculPercent(element.MASSE)} %</td>
        </tr>
      {/each}
    </tbody>
  </table>
  <span class="note text-secondary"
    >(1) masse salariale = salaire+prime+autres</span
  >
  <h5>Salaires par poste</h5>
  <SalaireParPoste />
{/await}

<style>
  .table {
    font-size: 0.6em;
  }
  .note {
    font-size: 0.4em;
    font-style: italic;
  }
</style>
